
// src/web/components/user-notification-panel.jsx

import React from 'react'
import connect from '../../connects/user-notification-panel'
import {
  Card,
  CardText,
} from 'react-toolbox'
import {
  List,
  ListItem,
  ListSubHeader,
  ListDivider,
} from 'react-toolbox/lib/list'
import Loading from './loading.jsx'
import Avatar from 'react-toolbox/lib/avatar'
import theme from './themes/flat-card.css'
import UserNotificationList from './themes/user-notification-list.css'
import Switch from 'react-toolbox/lib/switch'
import _ from 'lodash'
import Dropdown from 'react-toolbox/lib/dropdown'

const settingsMenuItems = [
  { value: 'none', icon: 'notifications_off', caption: 'label:通知none', isMail: false, isPush: false},
  { value: 'mail', icon: 'mail_outline', caption: 'label:通知mail', isMail: true, isPush: false},
  { value: 'push', icon: 'tap_and_play', caption: 'label:通知push', isMail: false, isPush: true },
  { value: 'all',  icon: 'notifications_active', caption: 'label:通知all', isMail: true, isPush: true },
]

// notify_alert_disyplay: mail means the flag for showing new message or not
// notify_alert_disyplay: push means the flag for showing message content or not

const scheduleTypeList = [
  { value: 'everyday', label: '毎日' },
  { value: 'weekday', label: '平日' },
  { value: 'custom', label: 'カスタム' }
]

const timeList = _.times(48, (index) => {
  let hour = Math.floor(index / 2).toString().padStart(2, '0');
  let minute = index % 2 === 0 ? '00' : '30';

  return { value: `${hour}:${minute}`, label: `${hour}:${minute}` };
});

// Add "none" option at the beginning to custom start time list
const customTimeList = [{ value: 'none', label: 'なし' }, ...timeList];

function SettingMenu(props) {
  const {
    t,
    selected,
    target,
    notification,
    disableNone,
    updateSetting,
    updateCollectiveSetting,
    group,
    groups,
    isSameSetting,
    setAllSettingToStore,
    updateUI
  } = props

  const onChange = (value) => {
    const list = _.filter(settingsMenuItems, (item) => (item.isMail == value.isMail) && (item.isPush == value.isPush))
    if(group && groups){
      updateSetting(target, notification, list[0].value, group, groups, false, undefined)
    }
    else if(isSameSetting && groups){
      updateCollectiveSetting && updateCollectiveSetting(value.type, value.type == 'mail' ? value.isMail : value.isPush)
      setAllSettingToStore(list[0].value)
      updateUI({ allSetting: list[0].value })
    }
    else{
      updateSetting(target, notification, list[0].value)
    }
  }

  const initialState = _.filter(settingsMenuItems, (item) => item.value == (selected? selected : 'none'))[0]

  return (
    <div className={theme.rightButton}>
      <Switch className={disableNone ? theme.singleSwitch : theme.switch}
        checked={initialState.isMail}
        onChange={(value) => onChange({ isMail: value, isPush: initialState.isPush, isAllPush: false, type: 'mail' })}/>
      {!disableNone && <Switch
        className={theme.switch}  
        checked={disableNone ? true :initialState.isPush}
        disabled={disableNone}
        onChange={(value) => onChange({ isMail: initialState.isMail, isPush: disableNone ? true : value, isAllPush: true, type: 'push' })}/>}
    </div>
  )
}

class UserNotificationPanel extends React.Component {
  state = {}

  onChangeActive = (status)=> {
    this.props.updateScheduleActive(status)
  } 

  onUpdateType = (value)=> {
    this.props.updateScheduleType(value)
  } 

  onUpdateDaySchedule = (value)=> {
    this.props.updateDaySchedule(value.schedule_type, value.type, value.time)
  } 

  onUpdateCustomSchedule = (value)=> {
    this.props.updateCustomSchedule(value.day_of_week, value.type, value.time)
  } 

  render() {
    const {
      t,
      ui,
      updateUI,
      isNotificationUpdating,
      notificationSettings,
      updateSetting,
      updateCollectiveSetting,
      setAllSettingToStore,
      updateScheduleType,
      updateScheduleActive,
      updateDaySchedule,
      updateCustomSchedule,
    } = this.props
    const {
      groups,
      others,
      schedule,
    } = this.props.notificationSettings

    return (
      <Card theme={theme}>
          {isNotificationUpdating && !groups && !others &&
            <Loading />
          }
        <CardText theme={UserNotificationList}>
          <List selectable={false} ripple={false} >
            {schedule && 
              <div>
                <ListItem key="head-other"
                  className={UserNotificationList.head}
                  selectable={false}
                  ripple={false}
                  caption={t('label:通知スケジュールを設定する')}
                  rightActions={[
                    <Switch className={theme.switch} checked={schedule.is_active} onChange={this.onChangeActive} />
                  ]}
                />
                <ListDivider key="div" theme={UserNotificationList} />
                <p 
                  style={{
                    marginTop: 10,
                    marginLeft: 15,
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                    whiteSpace: 'normal',
                    maxWidth: '100%',
                  }}
                  >{t('label:通知スケジュールを設定文言')}
                </p>
                <Dropdown auto
                  className={UserNotificationList.type_dropdown}
                  source={scheduleTypeList}
                  value={schedule.schedule_type}
                  onChange={this.onUpdateType}
                />
                {schedule.schedule_type != 'custom' &&
                <div>
                  <span className={UserNotificationList.schedule_title}>{t('label:時間')}</span>
                  <Dropdown auto
                    className={UserNotificationList.schedule_dropdown}
                    source={timeList}
                    value={schedule.schedule_type == 'everyday' ? schedule.everyday_start : schedule.weekday_start}
                    onChange={(value) => this.onUpdateDaySchedule({ schedule_type: schedule.schedule_type, type: 'start', time: value })}
                  />
                  <span className={UserNotificationList.schedule_desc}>から</span>
                  <Dropdown auto
                    className={UserNotificationList.schedule_dropdown}
                    source={timeList}
                    value={schedule.schedule_type == 'everyday' ? schedule.everyday_end : schedule.weekday_end}
                    onChange={(value) => this.onUpdateDaySchedule({ schedule_type: schedule.schedule_type, type: 'end', time: value })}
                  />
                </div>
                }
                {schedule.schedule_type == 'custom' &&
                <div>
                  <div>
                    <span className={UserNotificationList.schedule_title}>{t('label:send_on_mon')}</span>
                    <Dropdown auto
                      className={UserNotificationList.schedule_dropdown}
                      source={customTimeList}
                      value={schedule.monday_start}
                      onChange={(value) => this.onUpdateCustomSchedule({ day_of_week: 'monday', type: 'start', time: value })}
                    />
                    {schedule.monday_start != 'none' &&
                    <div style={{ display: 'inline-block' }}>
                      <span className={UserNotificationList.schedule_desc}>から</span>
                      <Dropdown auto
                        className={UserNotificationList.schedule_dropdown}
                        source={timeList}
                        value={schedule.monday_end}
                        onChange={(value) => this.onUpdateCustomSchedule({ day_of_week: 'monday', type: 'end', time: value })}
                      />
                    </div>
                    }
                  </div>
                  <div>
                    <span className={UserNotificationList.schedule_title}>{t('label:send_on_tue')}</span>
                    <Dropdown auto
                      className={UserNotificationList.schedule_dropdown}
                      source={customTimeList}
                      value={schedule.tuesday_start}
                      onChange={(value) => this.onUpdateCustomSchedule({ day_of_week: 'tuesday', type: 'start', time: value })}
                    />
                    {schedule.tuesday_start != 'none' &&
                    <div style={{ display: 'inline-block' }}>
                      <span className={UserNotificationList.schedule_desc}>から</span>
                      <Dropdown auto
                        className={UserNotificationList.schedule_dropdown}
                        source={timeList}
                        value={schedule.tuesday_end}
                        onChange={(value) => this.onUpdateCustomSchedule({ day_of_week: 'tuesday', type: 'end', time: value })}
                      />
                    </div>
                    }
                  </div>
                  <div>
                    <span className={UserNotificationList.schedule_title}>{t('label:send_on_wed')}</span>
                    <Dropdown auto
                      className={UserNotificationList.schedule_dropdown}
                      source={customTimeList}
                      value={schedule.wednesday_start}
                      onChange={(value) => this.onUpdateCustomSchedule({ day_of_week: 'wednesday', type: 'start', time: value })}
                    />
                    {schedule.wednesday_start != 'none' &&
                    <div style={{ display: 'inline-block' }}>
                      <span className={UserNotificationList.schedule_desc}>から</span>
                      <Dropdown auto
                        className={UserNotificationList.schedule_dropdown}
                        source={timeList}
                        value={schedule.wednesday_end}
                        onChange={(value) => this.onUpdateCustomSchedule({ day_of_week: 'wednesday', type: 'end', time: value })}
                      />
                    </div>
                    }
                  </div>
                  <div>
                    <span className={UserNotificationList.schedule_title}>{t('label:send_on_thu')}</span>
                    <Dropdown auto
                      className={UserNotificationList.schedule_dropdown}
                      source={customTimeList}
                      value={schedule.thursday_start}
                      onChange={(value) => this.onUpdateCustomSchedule({ day_of_week: 'thursday', type: 'start', time: value })}
                    />
                    {schedule.thursday_start != 'none' &&
                    <div style={{ display: 'inline-block' }}>
                      <span className={UserNotificationList.schedule_desc}>から</span>
                      <Dropdown auto
                        className={UserNotificationList.schedule_dropdown}
                        source={timeList}
                        value={schedule.thursday_end}
                        onChange={(value) => this.onUpdateCustomSchedule({ day_of_week: 'thursday', type: 'end', time: value })}
                      />
                    </div>
                    }
                  </div>
                  <div>
                    <span className={UserNotificationList.schedule_title}>{t('label:send_on_fri')}</span>
                    <Dropdown auto
                      className={UserNotificationList.schedule_dropdown}
                      source={customTimeList}
                      value={schedule.friday_start}
                      onChange={(value) => this.onUpdateCustomSchedule({ day_of_week: 'friday', type: 'start', time: value })}
                    />
                    {schedule.friday_start != 'none' &&
                    <div style={{ display: 'inline-block' }}>
                      <span className={UserNotificationList.schedule_desc}>から</span>
                      <Dropdown auto
                        className={UserNotificationList.schedule_dropdown}
                        source={timeList}
                        value={schedule.friday_end}
                        onChange={(value) => this.onUpdateCustomSchedule({ day_of_week: 'friday', type: 'end', time: value })}
                      />
                    </div>
                    }
                  </div>
                  <div>
                    <span className={UserNotificationList.schedule_title}>{t('label:send_on_sat')}</span>
                    <Dropdown auto
                      className={UserNotificationList.schedule_dropdown}
                      source={customTimeList}
                      value={schedule.saturday_start}
                      onChange={(value) => this.onUpdateCustomSchedule({ day_of_week: 'saturday', type: 'start', time: value })}
                    />
                    {schedule.saturday_start != 'none' &&
                    <div style={{ display: 'inline-block' }}>
                      <span className={UserNotificationList.schedule_desc}>から</span>
                      <Dropdown auto
                        className={UserNotificationList.schedule_dropdown}
                        source={timeList}
                        value={schedule.saturday_end}
                        onChange={(value) => this.onUpdateCustomSchedule({ day_of_week: 'saturday', type: 'end', time: value })}
                      />
                    </div>
                    }
                  </div>
                  <div>
                    <span className={UserNotificationList.schedule_title}>{t('label:send_on_sun')}</span>
                    <Dropdown auto
                      className={UserNotificationList.schedule_dropdown}
                      source={customTimeList}
                      value={schedule.sunday_start}
                      onChange={(value) => this.onUpdateCustomSchedule({ day_of_week: 'sunday', type: 'start', time: value })}
                    />
                    {schedule.sunday_start != 'none' &&
                    <div style={{ display: 'inline-block' }}>
                      <span className={UserNotificationList.schedule_desc}>から</span>
                      <Dropdown auto
                        className={UserNotificationList.schedule_dropdown}
                        source={timeList}
                        value={schedule.sunday_end}
                        onChange={(value) => this.onUpdateCustomSchedule({ day_of_week: 'sunday', type: 'end', time: value })}
                      />
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
            }
            {others && [
              <ListItem key="head-other"
                  className={UserNotificationList.head}
                  selectable={false}
                  ripple={false}
                  caption={t('label:共通設定')} />,
              <div key="title" className={theme.notificationContainer}>
                <div key={'new_message'} className={theme.leftLabel}>{t('label:通知を表示')}</div>
                <div key={'display_message'} className={theme.rightLabel}>{t('label:内容を表示')}</div>
              </div>,
              <ListItem key="chat-alert-display"
                disabled={isNotificationUpdating}
                ripple={false}
                legend={t('label:チャット通知設定')}
                rightActions={[
                  <SettingMenu key="chat-alert-display" t={t} selected={others.notify_on_alert_display_to_chat} updateSetting={updateSetting} target={'chat'} notification={'alert_display'} />
              ]} />,
              <div key="title" className={theme.notificationContainer}>
                <div key={'mail'} className={theme.leftLabel}>{t('label:通知mail')}</div>
                <div key={'app'} className={theme.rightLabel}>{t('label:通知push')}</div>
              </div>,
              <ListItem key="reply-other"
                  disabled={isNotificationUpdating}
                  ripple={false}
                  legend={t('label:返信があった時')}
                  rightActions={[
                    <SettingMenu key="reply" t={t} selected={others.notify_on_reply_to_me} updateSetting={updateSetting} target={'me'} notification={'reply'}/>,
                  ]} />,
              <ListItem key="mention-other"
                  disabled={isNotificationUpdating}
                  ripple={false}
                  legend={t('label:読んでみてがあった時')}
                  rightActions={[
                    <SettingMenu key="mention" t={t} selected={others.notify_on_mention_to_me} updateSetting={updateSetting} target={'me'} notification={'mention'} />,
                  ]} />,
							<ListItem key="mention-delivered-other"
                  disabled={isNotificationUpdating}
                  ripple={false}
                  legend={t('label:読んでみてが開封された時')}
                  rightActions={[
                    <SettingMenu key="mention-deliver" t={t} selected={others.notify_on_mention_delivered_to_me} updateSetting={updateSetting} target={'me'} notification={'mention_delivered'} />,
                  ]} />,
              <ListItem key="post-other"
                  disabled={isNotificationUpdating}
                  ripple={false}
                  legend={t('label:お気に入りに投稿があった時')}
                  rightActions={[
                    <SettingMenu key="post" t={t} selected={others.notify_on_post_to_favorite} updateSetting={updateSetting} target={'favorite'} notification={'post'} />
                  ]} />,
              <ListItem key="chat-other"
                  disabled={isNotificationUpdating}
                  ripple={false}
                  legend={t('label:チャットを受信した時')}
                  rightActions={[
                    <SettingMenu key="chat" t={t} disableNone selected={others.notify_on_message_to_chat} updateSetting={updateSetting} target={'chat'} notification={'message'} />
                ]} />,
            ]}
            <ListItem key="head-other"
              className={UserNotificationList.head}
              selectable={false}
              ripple={false}
              caption={t('label:グループ設定')} />
            <div key="title" className={theme.notificationContainer}>
              <div key={'mail'} className={theme.leftLabel}>{t('label:通知mail')}</div>
              <div key={'app'} className={theme.rightLabel}>{t('label:通知push')}</div>
            </div>
            <ListItem key={'allsetting'}
                  ripple={false}
                  disabled={isNotificationUpdating}
                  caption={t('label:一括設定')}
                  legend={t('label:一括設定説明')}
                  rightActions={[
                    <SettingMenu key='all' t={t} selected={ui.allSetting||'all'} updateSetting={updateSetting} updateCollectiveSetting={updateCollectiveSetting} target={'group'} notification={'post'} groups={groups} isSameSetting={true} setAllSettingToStore={setAllSettingToStore} updateUI={updateUI}/>
                  ]} />

            {groups && _.map(groups, (group)=> [
              <ListSubHeader key={'head' + group.group_id}
                  theme={UserNotificationList}
                  caption={<span><Avatar image={group.icon_image.thumb_url} />&nbsp;{group.name}</span>} />,
              <div key="title" className={theme.notificationContainer}>
                <div key={'mail'} className={theme.leftLabel}>{t('label:通知mail')}</div>
                <div key={'app'} className={theme.rightLabel}>{t('label:通知push')}</div>
              </div>,
              <ListItem key={'post'+group.group_id}
                  ripple={false}
                  disabled={isNotificationUpdating}
                  legend={t('label:投稿があった時')}
                  rightActions={[
                    <SettingMenu key='post' t={t} selected={group.notify_on_post_to_group} updateSetting={updateSetting} target={'group'} notification={'post'} group={group} groups={groups} isSameSetting={false}/>
                  ]} />,
              <ListItem key={'comment'+group.group_id}
                  ripple={false}
                  disabled={isNotificationUpdating}
                  legend={t('label:コメントがあった時')}
                  rightActions={[
                    <SettingMenu key='comment' t={t} selected={group.notify_on_comment_to_group} updateSetting={updateSetting} target={'group'} notification={'comment'} group={group} groups={groups} isSameSetting={false}/>
                  ]} />,
              <ListItem key={'like'+group.group_id}
                  ripple={false}
                  disabled={isNotificationUpdating}
                  legend={t('label:いいねがあった時')}
                  rightActions={[
                    <SettingMenu key='like' t={t} selected={group.notify_on_like_to_group} updateSetting={updateSetting} target={'group'} notification={'like'} group={group} groups={groups} isSameSetting={false}/>
                  ]} />,
            ])}
          </List>
        </CardText>
      </Card>
    )
  }
}

export const RawUserNotificationPanel = UserNotificationPanel
export default connect(UserNotificationPanel)


// WEBPACK FOOTER //
// ./src/web/components/user-notification-panel.jsx